import { useQuery } from '@tanstack/react-query';

import { getImageCoverageInsightTotalForEntity } from 'apis/merchant-gateway/insights/image-coverage/api';
import useImageCoverageFeatureFlag from 'modules/insights-v2/hooks/useImageCoverageFeatureFlag';
import { InsightEntity } from 'modules/insights-v2/types';

type UseImageCoverageTotalInsightsParams = {
  insightEntity: InsightEntity;
};

export const useImageCoverageTotalInsights = ({ insightEntity }: UseImageCoverageTotalInsightsParams) => {
  const { isImageCoverageFeatureEnabled } = useImageCoverageFeatureFlag(insightEntity.type, insightEntity.id);

  const { data: imageCoverageTotalData, ...rest } = useQuery({
    queryKey: ['image-coverage-insights-total', insightEntity.id, insightEntity.type],
    queryFn: () =>
      getImageCoverageInsightTotalForEntity({ entityType: insightEntity.type, entityId: insightEntity.id }),
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: isImageCoverageFeatureEnabled,
  });

  const totalEntityImageCoverage = imageCoverageTotalData ? Math.floor(imageCoverageTotalData.total.coverage * 100) : 0;

  return {
    ...rest,
    totalEntityImageCoverage,
  };
};
